import { NumericMenuSelect } from 'components/molecules/refinement-numeric-menu'

import { TranslateFunc, useTranslate } from 'hooks/translation/use-translation'

export const tranOnSalePercentageLabel = (percentage: number, t: TranslateFunc, lang: string) => {
  if (percentage === 1) return t('Filters.Filters_on_sale_percentage_all')
  return t('Filters.Filters_on_sale_percentage_this_off_or_more', {
    percentage,
  })
}

export const getChineseDisplayPercentage = (percentage: number) => {
  return (100 - percentage) % 10 === 0 ? (100 - percentage) / 10 : 100 - percentage
}

const useOnSalePercentageFilter = () => {
  const { t, lang } = useTranslate('strapi-search-[...term]')

  const getOnSalePercentageRangeSelectInfos = (): NumericMenuSelect[] => {
    return [
      {
        label: tranOnSalePercentageLabel(1, t, lang),
        start: 1,
        end: 100,
      },
      {
        label: tranOnSalePercentageLabel(5, t, lang),
        start: 5,
        end: 100,
      },
      {
        label: tranOnSalePercentageLabel(10, t, lang),
        start: 10,
        end: 100,
      },
      {
        label: tranOnSalePercentageLabel(20, t, lang),
        start: 20,
        end: 100,
      },
      {
        label: tranOnSalePercentageLabel(30, t, lang),
        start: 30,
        end: 100,
      },
      {
        label: tranOnSalePercentageLabel(50, t, lang),
        start: 50,
        end: 100,
      },
    ]
  }

  return { getOnSalePercentageRangeSelectInfos }
}

export default useOnSalePercentageFilter
